import createIcon from '../../createIcon';

/**
 * @component @name CreditCardOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuNTU0NyAyMS4xOTVMMi43NTQ3MyAxLjM5NTAyTDEuMzQ0NzMgMi44MDUwMkwyLjg5NDczIDQuMzU1MDJDMi43NDQ3MyA0LjYzNTAyIDIuNjY0NzMgNC45NTUwMiAyLjY2NDczIDUuMjk1MDJMMi42NTQ3MyAxNy4yOTVDMi42NTQ3MyAxOC40MDUgMy41NDQ3MyAxOS4yOTUgNC42NTQ3MyAxOS4yOTVIMTcuODI0N0wyMS4xMzQ3IDIyLjYwNUwyMi41NTQ3IDIxLjE5NVpNNC42NTQ3MyAxMS4yOTVWNy4yOTUwMkg1LjgyNDczTDkuODI0NzMgMTEuMjk1SDQuNjU0NzNaTTcuNDg0NzMgMy4yOTUwMkgyMC42NTQ3QzIxLjc2NDcgMy4yOTUwMiAyMi42NTQ3IDQuMTg1MDIgMjIuNjU0NyA1LjI5NTAyVjE3LjI5NUMyMi42NTQ3IDE3LjYzNSAyMi41NzQ3IDE3Ljk1NSAyMi40MjQ3IDE4LjIzNUwxNS40ODQ3IDExLjI5NUgyMC42NTQ3VjcuMjk1MDJIMTEuNDg0N0w3LjQ4NDczIDMuMjk1MDJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CreditCardOff = createIcon('CreditCardOff', [
  [
    'path',
    {
      d: 'M22.5547 21.195L2.75473 1.39502L1.34473 2.80502L2.89473 4.35502C2.74473 4.63502 2.66473 4.95502 2.66473 5.29502L2.65473 17.295C2.65473 18.405 3.54473 19.295 4.65473 19.295H17.8247L21.1347 22.605L22.5547 21.195ZM4.65473 11.295V7.29502H5.82473L9.82473 11.295H4.65473ZM7.48473 3.29502H20.6547C21.7647 3.29502 22.6547 4.18502 22.6547 5.29502V17.295C22.6547 17.635 22.5747 17.955 22.4247 18.235L15.4847 11.295H20.6547V7.29502H11.4847L7.48473 3.29502Z',
      key: '1qo3wg',
    },
  ],
]);

export default CreditCardOff;
